// extracted by mini-css-extract-plugin
export default {"tooltip-short-term-rental":"components-hotel-short-term-rental-charts-chart-short-term-rental-evolution-range-module__tooltip-short-term-rental"};